
import { Component, Mixins } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class ReferenceTypeSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  get types() {
    return systemModule.referenceTypes.map(x => ({ label: x.displayId, value: x.id }));
  }
}
